(function (root) {
  'use strict';

  function createHoverAdvanceController(options) {
    var advance = options.advance;
    var canAdvance = options.canAdvance;
    var schedule = options.schedule || root.setTimeout.bind(root);
    var cancel = options.cancel || root.clearTimeout.bind(root);
    var initialDelay = options.initialDelay || 250;
    var repeatDelay = options.repeatDelay || 900;
    var timer = null;
    var active = false;

    function stop() {
      active = false;
      if (timer !== null) cancel(timer);
      timer = null;
    }

    function run() {
      timer = null;
      if (!active || !canAdvance()) {
        stop();
        return;
      }

      advance();
      timer = schedule(run, repeatDelay);
    }

    function start() {
      if (active) return;
      active = true;
      timer = schedule(run, initialDelay);
    }

    return { start: start, stop: stop };
  }

  function supportsHoverAdvance(environment) {
    return Boolean(
      environment &&
      typeof environment.matchMedia === 'function' &&
      environment.matchMedia('(hover: hover) and (pointer: fine)').matches
    );
  }

  function initCarouselHoverAdvance(scope) {
    var target = scope || document;
    var selector = [
      '.hs-edge-arrow',
      '.hs2-edge-arrow',
      '[class*="custom-tab-arrow-"]',
      '.falcon-supplies-edge-arrow',
      '.bl-edge-arrow',
      '.falcon-slider-arrow'
    ].join(',');

    target.querySelectorAll(selector).forEach(function (button) {
      if (button.dataset.falconHoverAdvance === 'true') return;
      button.dataset.falconHoverAdvance = 'true';

      if (!supportsHoverAdvance(root)) return;

      var controller = createHoverAdvanceController({
        advance: function () { button.click(); },
        canAdvance: function () {
          return !button.disabled && !button.hidden && button.getAttribute('aria-disabled') !== 'true';
        },
        initialDelay: 250,
        repeatDelay: 900
      });

      button.addEventListener('mouseenter', controller.start);
      button.addEventListener('mouseleave', controller.stop);
      button.addEventListener('blur', controller.stop);
    });
  }

  root.FalconCarouselHover = {
    createHoverAdvanceController: createHoverAdvanceController,
    supportsHoverAdvance: supportsHoverAdvance,
    init: initCarouselHoverAdvance
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      createHoverAdvanceController: createHoverAdvanceController,
      supportsHoverAdvance: supportsHoverAdvance
    };
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarouselHoverAdvance(document); });
  } else {
    initCarouselHoverAdvance(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCarouselHoverAdvance(event.target);
  });
})(typeof window !== 'undefined' ? window : globalThis);
